// // src/pages/AnalyticsSection.js
// import React, { useEffect, useState, useRef } from "react";
// import "./Styles.css";
// import AOS from "aos";
// import "aos/dist/aos.css";

// const AnalyticsSection = () => {
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [stats, setStats] = useState({
//     totalUsers: 0,
//     totalMessages: 0,
//     totalCharacters: 0,
//   });

//   useEffect(() => {
//     // init AOS (optional, for fade animations)
//     AOS.init({ duration: 800, once: true });

//     const fetchStats = async () => {
//       try {
//         setLoading(true);
//         setError("");

//         const res = await fetch(
//           "https://landing.guftagu.net/contact/dashboard-stats/"
//         );
//         console.log("RES STATUS:", res.status);

//         const text = await res.text();
//         console.log("RAW RESPONSE:", text);

//         if (!res.ok) {
//           throw new Error("Failed to fetch stats");
//         }

//         const data = JSON.parse(text);
//         console.log("PARSED DATA:", data);

//         setStats({
//           totalUsers: data.totalUsers || 0,
//           totalMessages: data.totalMessages || 0,
//           totalCharacters: data.totalCharacters || 0,
//         });
//       } catch (err) {
//         console.error("FETCH ERROR:", err);
//         setError("Unable to load latest stats right now.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchStats();
//   }, []);

//   return (
//     <section className="analytics-section pb-5" id="analytics">
//       <div className="analytics-gradient-overlay" />

//       <div className="container position-relative">
//         <div className="row g-4 justify-content-center" data-aos="fade-up">
//           <StatCard
//             title="Onboarded Users"
//             value={!loading && !error ? stats.totalUsers : 0}
//             icon="bi-people-fill"
//             variant="users"
//           />
//           <StatCard
//             title="Messages Shared by Users"
//             value={!loading && !error ? stats.totalMessages : 0}
//             icon="bi-chat-dots-fill"
//             variant="messages"
//           />
//           <StatCard
//             title="AI Characters Created"
//             value={!loading && !error ? stats.totalCharacters : 0}
//             icon="bi-robot"
//             variant="characters"
//           />
//         </div>
//       </div>
//     </section>
//   );
// };

// // Count-up animation component (unchanged logic, just reused)
// const CountUp = ({ target, duration = 1200 }) => {
//   const [value, setValue] = useState(0);
//   const finalValue = Number(target) || 0;

//   useEffect(() => {
//     let frameId;
//     const startTime = performance.now();

//     const animate = (now) => {
//       const elapsed = now - startTime;
//       const progress = Math.min(elapsed / duration, 1);
//       const current = Math.floor(progress * finalValue);
//       setValue(current);

//       if (progress < 1) {
//         frameId = requestAnimationFrame(animate);
//       }
//     };

//     frameId = requestAnimationFrame(animate);

//     return () => {
//       if (frameId) cancelAnimationFrame(frameId);
//     };
//   }, [finalValue, duration]);

//   return <span>{value.toLocaleString()}</span>;
// };

// // ⬇️ Here we detect when the card is in viewport and then start the count
// const StatCard = ({ title, value, icon, variant }) => {
//   const cardRef = useRef(null);
//   const [isVisible, setIsVisible] = useState(false);

//   useEffect(() => {
//     const el = cardRef.current;
//     if (!el) return;

//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setIsVisible(true);     // trigger animation
//           observer.unobserve(el); // only once
//         }
//       },
//       {
//         threshold: 0.4, // 40% of card visible
//       }
//     );

//     observer.observe(el);

//     return () => {
//       observer.disconnect();
//     };
//   }, []);

//   return (
//     <div className="col-md-4 col-sm-6 col-12" ref={cardRef}>
//       <div className={`stat-card glass-card stat-${variant} fade-in-card`}>
//         <div className="stat-card-glow" />
//         <div className="stat-card-inner text-center">
//           <div className="stat-icon-wrapper mb-3">
//             <div className="stat-icon">
//               <i className={`bi ${icon}`}></i>
//             </div>
//           </div>
//           <p className="stat-value">
//             {/* Only count up when visible; before that it shows 0 */}
//             <CountUp target={isVisible ? value : 0} />
//           </p>
//           <h6 className="text-uppercase small mb-1 stat-label mb-0">{title}</h6>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AnalyticsSection;
import React, { useEffect, useState, useRef } from "react";
import "./Styles.css";
import AOS from "aos";
import "aos/dist/aos.css";

const BASE_USERS = 3400; 

const AnalyticsSection = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [stats, setStats] = useState({
    preRegisteredUsers: 0,
    totalUsers: 0,
  });

  useEffect(() => {
    AOS.init({ duration: 800, once: true });

    const fetchStats = async () => {
      try {
        setLoading(true);
        setError("");

        const res = await fetch(
          "https://landing.guftagu.net/contact/adopters/"
        );

        if (!res.ok) {
          throw new Error("Failed to fetch users");
        }

        const data = await res.json();
        const adoptersCount = data.count ?? 0;

        // ✅ Add base users
        const finalUserCount = BASE_USERS + adoptersCount;

        setStats({
          preRegisteredUsers: finalUserCount,
          totalUsers: finalUserCount,
        });
      } catch (err) {
        console.error("FETCH ERROR:", err);
        setError("Unable to load user stats.");
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  return (
    <section className="analytics-section pb-5" id="analytics">
      <div className="analytics-gradient-overlay" />

      <div className="container position-relative">
        <div className="row g-4 justify-content-center" data-aos="fade-up">
          
          {/* ✅ TOTAL USERS
          <StatCard
            title="Total Users"
            value={!loading && !error ? stats.totalUsers : 0}
            icon="bi-people-fill"
            variant="users"
          /> */}

          {/* ✅ PRE-REGISTERED USERS */}
          <StatCard
            title="Pre-Registered Users"
            value={!loading && !error ? stats.preRegisteredUsers : 0}
            icon="bi-person-plus-fill"
            variant="users"
          />

        </div>
      </div>
    </section>
  );
};

const CountUp = ({ target, duration = 1200 }) => {
  const [value, setValue] = useState(0);

  useEffect(() => {
    let frameId;
    const start = performance.now();

    const animate = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      setValue(Math.floor(progress * target));
      if (progress < 1) frameId = requestAnimationFrame(animate);
    };

    frameId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frameId);
  }, [target, duration]);

  return <span>{value.toLocaleString()}</span>;
};

const StatCard = ({ title, value, icon, variant }) => {
  const cardRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.4 }
    );

    if (cardRef.current) observer.observe(cardRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="col-md-4 col-sm-6 col-12" ref={cardRef}>
      <div className={`stat-card glass-card stat-${variant}`}>
        <div className="stat-card-inner text-center">
          <div className="stat-icon mb-3">
            <i className={`bi ${icon}`} />
          </div>

          <p className="stat-value">
            <CountUp target={visible ? value : 0} />
          </p>

          <h6 className="fw-bolder mb-0 text-success">{title}</h6>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsSection;